var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4813 7.05273C21.2649 7.05273 6.61133 21.7258 6.61133 39.9261V473.159C6.61133 491.36 21.2649 506 39.4813 506H473.098C491.314 506 506 491.36 506 473.159V39.9261C506 21.7258 491.314 7.05273 473.098 7.05273H39.4813V7.05273Z",
    fill: "#C0392B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.671 6L250.102 212.173L280.534 6H219.671ZM466.927 6L250.102 241.993L33.6354 6.3898C17.9327 8.88942 6 22.4585 6 38.8734V59.0457L250.102 251.901L505.389 50.1776V38.8734C505.389 20.6731 490.703 6 472.486 6H466.927ZM250.102 251.901L505.389 292.245V211.588L250.102 251.901V251.901ZM250.102 251.901L6 444.788V472.107C6 486.615 15.3302 498.822 28.3359 503.193L250.102 261.841L473.429 504.915C491.204 504.417 505.389 489.99 505.389 472.107V453.624L250.102 251.901ZM250.102 251.901L6 213.343V290.491L250.102 251.901V251.901ZM250.102 291.66L218.598 504.948H281.574L250.102 291.66V291.66Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.21 255.346C189.386 238.366 196.591 222.149 209.239 210.261C221.887 198.373 238.942 191.788 256.654 191.954C274.366 192.121 291.284 199.025 303.687 211.148C316.09 223.271 322.961 239.62 322.791 256.6C322.62 273.58 315.421 289.799 302.776 301.691C290.132 313.583 273.079 320.173 255.367 320.011C237.654 319.85 220.734 312.951 208.328 300.832C195.921 288.712 189.044 272.365 189.21 255.385",
    fill: "#F1C40F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.21 255.346C189.386 238.366 196.591 222.149 209.239 210.261C221.887 198.373 238.942 191.788 256.654 191.954C274.366 192.121 291.284 199.025 303.687 211.148C316.09 223.271 322.961 239.62 322.791 256.6C322.62 273.58 315.421 289.799 302.776 301.691C290.132 313.583 273.079 320.173 255.367 320.011C237.654 319.85 220.734 312.951 208.328 300.832C195.921 288.712 189.044 272.365 189.21 255.385",
    stroke: "#C0392B",
    strokeWidth: 10.3993
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/MK.79726d5d4a7410888f5876fbe5a04621.svg";
export { ForwardRef as ReactComponent };